import { Flex, Image, Show, Text } from "@chakra-ui/react";
import React, { memo } from "react";

export default memo(function HomeHeaderComponent() {
   return (
      <>
         <Image
            alt=""
            userSelect={"none"}
            className="refImg"
            src={undefined}
            pos={"absolute"}
            left={0}
            top={{ base: "-50px", BREAK_PAD: "-70px", BREAK_LPC: "-85px", BREAK_PC: "-100px" }}
            w={{ base: "120px", BREAK_PAD: "240px", BREAK_LPC: "360px", BREAK_PC: "480px" }}
            data-src={process.env.REACT_APP_PUBLIC_URL + "images/skin_left_icon.png"}
         />
         <Image
            alt=""
            userSelect={"none"}
            className="refImg"
            src={undefined}
            pos={"absolute"}
            right={0}
            top={"120px"}
            w={{ base: "100px", BREAK_PAD: "180px", BREAK_LPC: "260px", BREAK_PC: "330px" }}
            data-src={process.env.REACT_APP_PUBLIC_URL + "images/skin_right_icon.png"}
         />
         <Image
            alt=""
            userSelect={"none"}
            className="refImg"
            src={undefined}
            pos={"absolute"}
            right={{ base: "0px",BREAK_PAD:'20px', BREAK_LPC: "50px" }}
            w={{ base: "44px",BREAK_PAD:'80px',BREAK_LPC: "144px" }}
            top={"770px"}
            data-src={process.env.REACT_APP_PUBLIC_URL + "images/skin_bottom_icon.png"}
         />

         <Show above={"BREAK_LPC"}>
            <Image
               alt=""
               userSelect={"none"}
               pos={"absolute"}
               right={{ base: "0px", BREAK_LPC: "50px" }}
               w={{ base: "44px", BREAK_LPC: "144px" }}
               top={"2300px"}
               src={process.env.REACT_APP_PUBLIC_URL + "images/skin_bottom_icon.png"}
            /> 
            <Image
               alt=""
               userSelect={"none"}
               pos={"absolute"}
               right={{ base: "0px", BREAK_LPC: "50px" }}
               w={{ base: "44px", BREAK_LPC: "144px" }}
               top={"4350px"}
               src={process.env.REACT_APP_PUBLIC_URL + "images/skin_bottom_icon.png"}
            />
            <Image
               alt=""
               userSelect={"none"}
               pos={"absolute"}
               left={{ base: "0px", BREAK_LPC: "50px" }}
               w={{ base: "44px", BREAK_LPC: "144px" }}
               top={"1350px"}
               src={process.env.REACT_APP_PUBLIC_URL + "images/skin_bottom_icon.png"}
            />
         </Show>

         <Flex flexDir={"column"} mx={"auto"} alignItems="center" zIndex={"1"}>
            <Text
               fontSize={{ base: "26px", BREAK_PAD: "35px", BREAK_LPC: "40px", BREAK_PC: "46px" }}
               color={"black"}
               fontFamily={"Arial-BoldMT"}
               maxW={"100%"}
               textAlign="center">
               Aloha Twitter & Discord Bots for NFT Collections
            </Text>
            <Text
               textAlign={"center"}
               fontSize={{ base: "18px", BREAK_PAD: "22px", BREAK_LPC: "24px", BREAK_PC: "26px" }}
               mx={"20px"}
               maxW={{ base: "90%", BREAK_PAD: "80%", BREAK_LPC: "60%" }}>
               The most advanced and powerful tool to promote NFT projects and increase community engagement.
            </Text>
         </Flex>
      </>
   );
});
